const {ProMinusPopup} = require('./ProMinusPopup');

export default ProMinusPopup;
